var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _vm.userPermissions.indexOf("access_social_media_calendar") > -1
        ? _c("div", { staticClass: "container-fluid xyz" }, [
            _c("div", { staticClass: "page-name" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.pageTitle) + "\n            "
              ),
              _c(
                "button",
                {
                  staticClass: "back_button btn btn-primary pull-right",
                  attrs: { type: "submit" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.buttonBack.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("Back")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-page-content" }, [
              _c("form", { attrs: { id: "socialMediaForm" } }, [
                _c(
                  "div",
                  { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.title,
                              expression: "title"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "title",
                            placeholder: "Title"
                          },
                          domProps: { value: _vm.title },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.title = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.titleError))
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("tinymce", {
                          ref: "tm",
                          attrs: {
                            plugins: [
                              "advlist autolink lists link image charmap print preview hr anchor pagebreak",
                              "searchreplace wordcount visualblocks visualchars code fullscreen",
                              "insertdatetime media nonbreaking save table contextmenu directionality",
                              "template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample"
                            ],
                            id: "description"
                          },
                          model: {
                            value: _vm.description,
                            callback: function($$v) {
                              _vm.description = $$v
                            },
                            expression: "description"
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.descriptionError))
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "hashTag" } }, [
                        _vm._v("Hash Tags")
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.hashTag,
                            expression: "hashTag"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "hashTag", placeholder: "Hash Tags" },
                        domProps: { value: _vm.hashTag },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.hashTag = $event.target.value
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "dropzone" } }, [
                          _vm._v("Attachments")
                        ]),
                        _vm._v(" "),
                        _c(
                          "vue-dropzone",
                          {
                            ref: "dropzone",
                            attrs: {
                              id: "dropzone",
                              options: _vm.dropzoneOptions,
                              useCustomSlot: true
                            },
                            on: {
                              "vdropzone-success": _vm.uploadDocument,
                              "vdropzone-removed-file": _vm.removedSelectedFile,
                              "vdropzone-error": _vm.fileError,
                              "vdropzone-file-added": _vm.fileAdd
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "dropzone-custom-content" },
                              [
                                _c(
                                  "h4",
                                  { staticClass: "dropzone-custom-title" },
                                  [
                                    _vm._v(
                                      "Drop files here or click to upload."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "subtitle" }, [
                                  _vm._v("(Select files from your computer.)")
                                ])
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("v-select", {
                          attrs: {
                            multiple: "",
                            name: "companies",
                            id: "companies",
                            label: "text",
                            filterable: false,
                            options: _vm.companyArr,
                            searchable: false,
                            placeholder: "Select Company"
                          },
                          on: {
                            change: _vm.changedValue,
                            input: function($event) {
                              return _vm.changedValueCompany()
                            }
                          },
                          model: {
                            value: _vm.companies,
                            callback: function($$v) {
                              _vm.companies = $$v
                            },
                            expression: "companies"
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.companyError))
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "StartDate col-lg-6 col-md-6 col-sm-12 col-xs-12"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            attrs: { slot: "before", for: "startDate" },
                            slot: "before"
                          },
                          [
                            _vm._v("Date"),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("datePicker", {
                          attrs: { id: "StartDate", config: _vm.optionsStart },
                          on: {
                            "dp-change": function($event) {
                              return _vm.changeStartDt()
                            }
                          },
                          model: {
                            value: _vm.startDate,
                            callback: function($$v) {
                              _vm.startDate = $$v
                            },
                            expression: "startDate"
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.startDateError))
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userId,
                              expression: "userId"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "userId",
                            placeholder: "Contact Person"
                          },
                          domProps: { value: _vm.userId },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.userId = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.contactPersonError))
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.contactEmail,
                              expression: "contactEmail"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "contactEmail",
                            placeholder: "Contact Email"
                          },
                          domProps: { value: _vm.contactEmail },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.contactEmail = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.contactEmailError))
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "contactNumber" } }, [
                          _vm._v("Contact Number")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.contactNumber,
                              expression: "contactNumber"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            id: "contactNumber",
                            placeholder: "Contact Number"
                          },
                          domProps: { value: _vm.contactNumber },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.contactNumber = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.contactNumberError))
                        ])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "createdBy" } }, [
                        _vm._v(_vm._s(_vm.createdByTitle))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "form-control",
                          attrs: { id: "createdBy" }
                        },
                        [_vm._v(_vm._s(_vm.createdBy))]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "row clearfix" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
                  [
                    _c("div", { staticClass: "button-demo" }, [
                      _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: {
                          id: "addSocialMediaBtn",
                          type: "submit",
                          value: "Save"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.addEvent()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: {
                          id: "addAndContinueSocialMediaBtn",
                          type: "submit",
                          value: "Save and Continue"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.addEvent(
                              (_vm.flag = "Save and Continue")
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "back_button btn btn-primary",
                        attrs: {
                          id: "CancelSocialMedia",
                          type: "submit",
                          value: "Cancel"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.buttonBack.apply(null, arguments)
                          }
                        }
                      })
                    ])
                  ]
                )
              ])
            ])
          ])
        : _c("div", { staticClass: "container-fluid xyz" }, [
            _c("div", { staticClass: "page-name" }, [
              _vm._v("\n            Oops...!\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-page-content" }, [
              _vm._v(
                "\n            Sorry, You don't have permission to access this page.\n        "
              )
            ])
          ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "title" } }, [
      _vm._v("Title"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "description" } }, [
      _vm._v("Description"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "companies" } }, [
      _vm._v("Companies To Share With"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "userId" } }, [
      _vm._v("Contact Person"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "contactEmail" } }, [
      _vm._v("Contact Email"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1091395e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1091395e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/socialmediacalendar/AddSocialEvent.vue
// module id = null
// module chunks = 